/// <amd-module name="VSS/Diagnostics/UI/Components/Settings/Settings" />
import * as React from "react";

import { Components, WrappedComponent } from "VSS/Platform/Layout";

interface ISettingsState {
    showSettingsDialog: boolean;
}

class Settings extends React.Component<{}, ISettingsState> {
    public state = { showSettingsDialog: false };

    public render(): JSX.Element {
        return (
            <React.Fragment>
                <span key="settings-section" className="perf-section actionable" onClick={this.showSettingsDialog}>
                    Settings...
                </span>
                {this.state.showSettingsDialog && (
                    <WrappedComponent
                        dependencies={["ms.vss-features.diag-dialog-content"]}
                        wrappedType="vss.perf-settings-dialog"
                        onDismiss={this.hideSettingsDialog}
                    />
                )}
            </React.Fragment>
        );
    }

    private hideSettingsDialog = () => {
        this.setState({ showSettingsDialog: false });
    };

    private showSettingsDialog = () => {
        this.setState({ showSettingsDialog: true });
    };
}

Components.add("perfbar.settingsSection", Settings);
